<div class="wrapper">
  <div class="calendar mb-4">
    <mat-calendar
      [class.hide-next]="!hasNext || !hasFreeSlots"
      [class.hide-prev]="!hasPrev || !hasFreeSlots"
      [dateClass]="dateClass"
      [(selected)]="selected"
      [headerComponent]="headerComponent"
      (selectedChange)="onChange()"
    ></mat-calendar>
  </div>
</div>
